export default __webpack_public_path__ + "static/media/jquery.5e93ff41.png";